import setLocale from './set-locale';

export default {
  setLocale,
};
